import { Typography } from '@mui/material'
import { useContext, useEffect } from 'react'
import { OpenIDContext } from '../../api/openid'
import SecDimAlert from '../../shared/SecDimAlert/SecDimAlert'

function GlobalAlerts() {
	const {
		isGlobalAlertShown,
		globalAlertMessage,
		globalAlertSeverity,
		setIsGlobalAlertShown,
		setGlobalAlertMessage,
		setGlobalAlertSeverity,
	} = useContext(OpenIDContext)

	useEffect(() => {
		if (!('Notification' in window)) {
			setGlobalAlertMessage('This browser does not support desktop notification')
			setGlobalAlertSeverity('error')
			setIsGlobalAlertShown(true)
		}
	}, [setGlobalAlertMessage, setGlobalAlertSeverity, setIsGlobalAlertShown])

	return (
		<SecDimAlert
			isAlertShown={isGlobalAlertShown}
			setAlertShown={setIsGlobalAlertShown}
			severity={globalAlertSeverity}
			alertMessage={<Typography>{globalAlertMessage}</Typography>}
		/>
	)
}

export default GlobalAlerts
